export const ExposureShader = {
  uniforms: {
    tDiffuse: { value: null },
    exposure: { value: 1.0 },
    gamma: { value: 1.0 },
  },
  vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform sampler2D tDiffuse;
    uniform float exposure;
    uniform float gamma;
    varying vec2 vUv;

    void main() {
      vec4 color = texture2D(tDiffuse, vUv);

      // Apply exposure
      vec3 exposed = color.rgb * pow(2.0, exposure);

      // Apply gamma correction
      vec3 gammaCorrected = pow(exposed, vec3(1.0 / gamma));

      gl_FragColor = vec4(gammaCorrected, color.a);
    }
  `,
};
